import { useTranslation } from "next-i18next";
import React, { useCallback } from "react";

import { CartFreeShippingProgress } from "@/components/CartFreeShippingProgress";
import { Button } from "@/components/elements/Button";
import { Icon } from "@/components/elements/Icon";
import { Text } from "@/components/elements/Text";
import { useAccountType } from "@/hooks/useAccountType/useAccountType";
import useGlobalState from "@/hooks/useGlobalState";
import useNotification from "@/hooks/useNotification";

import styles from "./styles.module.css";

export type NotificationItemAddedProps = {
  className?: string;
};

export const NotificationItemAdded = () => {
  const { t } = useTranslation();
  const { toggleCartIsOpen } = useGlobalState();
  const { dismissNotification } = useNotification();
  const { isBusinessAccount } = useAccountType();
  const openCart = useCallback(() => {
    toggleCartIsOpen();
    dismissNotification();
  }, [toggleCartIsOpen, dismissNotification]);
  return (
    <>
      <div className={styles.info}>
        <Text className={styles.title}>
          <Icon type="checkmark_circle" />
          {t("cart_confirmation_title")}
        </Text>

        <Button theme="underline" size="small" onClick={openCart}>
          {t("cart_confirmation_view")}
        </Button>
      </div>
      {/* PROGRESS BAR */}
      {isBusinessAccount ? null : (
        <CartFreeShippingProgress className={styles.progressBar} />
      )}
    </>
  );
};
